import React, { createContext, useState, useEffect } from "react";
import { getUserData } from "../components/common/utility/Utils";
import { LOCAL_STORAGE_KEY } from "../config";
const StoreContext = createContext();

const StoreProvider = (props) => {
  useEffect(() => {
    getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
       
        setIsUserLogin(true);
        // props.history.push("/Shipments")
      })
      .catch((err) => {
        console.log("error section", err);
        setIsUserLogin(false);
        // props.history.push("/Blogs")
      });
  }, []);

  //
  const [searchResult, setSearchResult] = useState([]);
  // set modal open and close
  const [modalOpen, setModalOpen] = useState(false);
  // sidebar open
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // provide modal type to distinguish different modal
  const [modalType, setModalType] = useState(false);

  //set shipmentid to show details
  const [shipmentId, setShipmentId] = useState("");
  const [co2ShipmentID, setco2ShipmentID]= useState("");
  console.log('d', co2ShipmentID)

  //set shipmentid to show details
  const [mblNum, setMblNum] = useState("");

  //set shipmentid to show details
  const [scacCode, setScacCode] = useState("");

  //decide when to show search screen and when hide
  const [searchResultView, setSearchResultView] = useState(false);

  //make header search input value available to all component
  const [searchInputValue, setSearchInputValue] = useState("");

  //Select shipment to view Details. hide on 0 shipment list
  const [rightHomeTitle, setRightHomeTitle] = useState(true);

  //show sidebar
  const [closeSidebar, setCloseSidebar] = useState(false);

  //to know search api is called by add filter component
  const [advFilterCall, setAdvFilterCall] = useState(false);

  //container details show
  const [containerShow, setContainerShow] = useState(true);

  //shipmentlist tabvalue
  const [tabValue, setTabValue] = React.useState(0);

  //mass Data
  const [massData, setMassData] = useState([]);
  console.log('mass123', massData)
  //notification handle
  const [notificationOpen, setNotificationOpen] = useState({
    type: "",
    open: false,
    orderPk: "",
    reload: false,
  });

  // omsuserdata set
  const [omsUserData, setOmsUserData] = React.useState({
    OrgPK: "",
    EmailId: "",
    FullName: "",
    Designation: "",
    Jobtitle: "",
    IsWebAccees: 0,
    IsActive: 0,
    OrgCodes: "",
    DirectRelatedOrgnisations: "",
    UserRoles: "",
  });

  //reuqest quote values
  const [requestQuote, setRequestQuote] = useState({
    origincountry: "",
    OriginPort: "",
    destinationCountry: "",
    destinationPort: "",
    availvableDirection: "",
    dateShip: "",
    weekAhead: "",
  });

  const calculateAmmount = (ammount) => {
    const amt = Number(parseFloat(ammount).toFixed(2)).toLocaleString("en", {
      minimumFractionDigits: 2,
    });
    return amt;
  };

  //advance search object
  const [advSearchFilter, setAdvSearchFilter] = useState({
    tranportMode: "",
    etd: "",
    eta: "",
  });
  //marked state of shipment

  //this objects is use for blogs data
  const [blogsData, setBlogsData] = useState([
    {
      id: 0,
      title: "Most Recent",
      post: [1, 2, 3, 4],
      loading: true,
      endPoint: 1,
      pageCount: 1,
      loadMore: false,
    },
    {
      id: 1,
      title: "Most Read",
      post: [1, 2, 3, 4],
      loading: true,
      endPoint: 194,
      pageCount: 1,
      loadMore: false,
    },
    {
      id: 2,
      title: "Shipping Trends",
      post: [1, 2, 3, 4],
      loading: true,
      endPoint: 11,
      pageCount: 1,
      loadMore: false,
    },
    {
      id: 3,
      title: "Supply Chain Planning",
      post: [1, 2, 3, 4],
      loading: true,
      endPoint: 9,
      pageCount: 1,
      loadMore: false,
    },
    {
      id: 4,
      title: "Project & Specialized Cargo",
      post: [1, 2, 3, 4],
      loading: true,
      endPoint: 14,
      pageCount: 1,
      loadMore: false,
    },
    {
      id: 5,
      title: "Industry News ",
      post: [1, 2, 3, 4],
      loading: true,
      endPoint: 22,
      pageCount: 1,
      loadMore: false,
    },
    {
      id: 6,
      title: "Global Trade",
      post: [1, 2, 3, 4],
      loading: true,
      endPoint: 5,
      pageCount: 1,
      loadMore: false,
    },
  ]);

  //this objects is used for
  const [blogsDetail, setBlogsDetail] = useState({
    image: "",
    detail: "",
    title: "",
  });

  const [blogsLoaded, setBlogsLoaded] = useState(false);

  //modal open function
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  //modal close function
  const handleModalClose = () => {
    setModalOpen(false);
  };

  //to store dashboard data
  const [dashboardData, setDashboardData] = useState({
    loaded: false,
    data: {},
  });

  const [isUserLogin, setIsUserLogin] = useState(false);

  const [lmdResponse, setLmdResponse] = useState({});

  return (
    <StoreContext.Provider
      value={{
        searchResult,
        modalOpen,
        modalType,
        shipmentId,
        scacCode,
        mblNum,
        blogsData,
        blogsDetail,
        blogsLoaded,
        dashboardData,
        searchResultView,
        searchInputValue,
        rightHomeTitle,
        isUserLogin,
        closeSidebar,
        advSearchFilter,
        advFilterCall,
        containerShow,
        tabValue,
        requestQuote,
        sidebarOpen,
        omsUserData,
        notificationOpen,
        lmdResponse,
        massData,
        co2ShipmentID,
        setMassData,
        setNotificationOpen,
        setOmsUserData,
        setSidebarOpen,
        calculateAmmount,
        setIsUserLogin,
        setDashboardData,
        setBlogsLoaded,
        setBlogsDetail,
        setBlogsData,
        setShipmentId,
        setco2ShipmentID,
        setScacCode,
        setMblNum,
        setSearchResult,
        setModalOpen,
        setModalType,
        handleModalOpen,
        handleModalClose,
        setSearchResultView,
        setSearchInputValue,
        setRightHomeTitle,
        setCloseSidebar,
        setAdvSearchFilter,
        setAdvFilterCall,
        setContainerShow,
        setTabValue,
        setRequestQuote,
        setLmdResponse,
      }}
    >
      {props.children}
    </StoreContext.Provider>
  );
};

export { StoreProvider, StoreContext };
